import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IWallet {
    bonusBalance: number;
    winBalance: number;
    walletType: string;
    id: string;
    name: string;
    balance: number;
    currency: string;
    parentWalletId: string;
    type: string;
    typename: string;
    userId: string;
    walletId?: string;
}

interface WalletState {
    userWallet: IWallet | null | undefined;
    userWalletList: IWallet[];
}

const initialState: WalletState = {
    userWallet: null,
    userWalletList: []
};

const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        setUserWalletList(state, action: PayloadAction<IWallet[]>) {
            state.userWalletList = action.payload;
            if (!state.userWallet && action.payload.length > 0) {
                state.userWallet = action.payload[0]; // Set the first wallet as default
            }
        },
        setUserWallet(state, action: PayloadAction<IWallet>) {
            state.userWallet = action.payload;
        },
        removeUserWalletList(state, action: PayloadAction<null>) {
            state.userWalletList = [];
            state.userWallet = null;
        }
    }
});

export const { setUserWallet, setUserWalletList, removeUserWalletList } = walletSlice.actions;
export const walletReducer = walletSlice.reducer;
